import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconSend } from '@components/icons/send';
import { IconTrash } from '@components/icons/trash';
import { Stack } from '@components/stack';

import { useStore } from 'models/Provider';
import { Box } from 'components/Box';
import { IntegrationField } from 'components/IntegrationField';
import { IntegrationHeader } from 'components/IntegrationHeader';
import { Loading } from 'components/Loading';

export const TeachableOnboarding = observer(
  ({ integration, saving, submit, validator, validating, remove }) => {
    integration.loadForApplication();
    const { t } = useStore();
    return (
      <>
        <IntegrationHeader integration={integration} />
        {integration.state === 'loading' && <Loading />}
        {integration.state !== 'loading' && !integration.triggered && (
          <Box mt="24" inactive={saving}>
            <Stack space={4}>
              {integration.data.map((data, i) => (
                <IntegrationField
                  data={data}
                  validator={validator}
                  refetch={integration.refetchForApplication}
                  key={i}
                />
              ))}
            </Stack>
            <Box flex justifyContent="flex-end" mt="20">
              <Button
                variant="primary-blue"
                style={{ marginLeft: 8 }}
                isDisabled={saving || integration.refetching}
                onClick={() => submit(false, true)}
                text={t('application.onboarding.integration.save')}
              />
              <Button
                style={{ marginLeft: 8 }}
                isDisabled={
                  saving ||
                  integration.refetching ||
                  integration.isBlocked ||
                  validating ||
                  integration.hasErrors()
                }
                onClick={() => submit(false, false)}
                iconLeft={<IconSend />}
                text={t('application.onboarding.integration.teachable.sendinvite')}
              />
            </Box>
          </Box>
        )}
        {integration.state !== 'loading' && integration.triggered && (
          <Box border padding="24" mt="24" backgroundColor="white">
            <Stack space={4}>
              {integration.data.map((data, i) => (
                <IntegrationField data={data} validator={validator} key={i} readOnly />
              ))}
            </Stack>
            <Box flex justifyContent="flex-end" mt="20">
              <Button
                variant="secondary"
                iconLeft={<IconTrash />}
                onClick={remove}
                text={t('application.onboarding.integration.remove')}
              />
            </Box>
          </Box>
        )}
      </>
    );
  }
);
